import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Hide the initial loader once React has mounted
setTimeout(() => {
  if (window.__hideLoader) window.__hideLoader();
}, 100);
